import React, { useState, useEffect } from 'react';
import AperturaCaja from './aperturaCaja';
import RegistroMovimiento from './registroMovimiento';
import CierreCaja from './cierreCaja.js';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const CajaManager = () => {
  const [cajaAbierta, setCajaAbierta] = useState(null);
  const [resumenCaja, setResumenCaja] = useState({});
  const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelado = false;

    const buscarOCrearCaja = async () => {
      try {
        let cajaId = localStorage.getItem('cajaAbiertaId');
        let caja = null;
        let totales = {};
        
        // 1. Intentar cargar la caja por ID guardado
        if (cajaId) {
          try {
            const res = await axios.get(`${import.meta.env.VITE_API_URL}/caja/${cajaId}`, {
              headers: { 'x-auth-token': token },
            });

            const { caja: cajaData, resumen } = res.data;

            if (cajaData && !cajaData.cerrada) {
              caja = cajaData;
              totales = resumen;
            } else {
              localStorage.removeItem('cajaAbiertaId');
              toast.info("La caja anterior fue cerrada. Buscando otra abierta.");
            }
          } catch (error) {
            console.error("Error al cargar caja guardada:", error);
            localStorage.removeItem('cajaAbiertaId');
            toast.warn("No se pudo recuperar la caja guardada. Buscando otra abierta.");
          }
        }

        // 2. Si no hay caja válida, buscar una abierta
        if (!caja) {
          try {
            const res = await axios.get(`${import.meta.env.VITE_API_URL}/caja/abierta`, {
              headers: { 'x-auth-token': token },
            });

            const { caja: cajaData, resumen } = res.data;

            if (cajaData && cajaData.id) {
              caja = cajaData;
              totales = resumen;
              localStorage.setItem('cajaAbiertaId', caja.id);
            }
          } catch (error) {
            console.warn("No se encontró caja abierta");
            // No mostrar toast si simplemente no hay caja abierta
          }
        }

        // 3. Setear estado si no fue cancelado
        if (!cancelado) {
          setCajaAbierta(caja || null);
          setResumenCaja(totales || {});
        }

      } catch (err) {
        console.error("Error general en carga de caja:", err);
        if (!cancelado) {
          toast.error("Error al buscar caja abierta.");
          setCajaAbierta(null);
          setResumenCaja({});
        }
      }
    };

    if (token) {
      buscarOCrearCaja();
    }

    return () => {
      cancelado = true;
    };
  }, [token, navigate]);

  useEffect(() => {
    if (cajaAbierta?.id) {
      localStorage.setItem('cajaAbiertaId', cajaAbierta.id);
    }
  }, [cajaAbierta]);

  const manejarCajaAbierta = (cajaData, totalesData = {}) => {
    if (cajaData?.id) {
      localStorage.setItem('cajaAbiertaId', cajaData.id);
      setCajaAbierta(cajaData);
  setResumenCaja(totalesData);
    }
  };

  const manejarMovimiento = async () => {
    try {
      const res = await axios.get(`${import.meta.env.VITE_API_URL}/caja/${cajaAbierta.id}`, {
        headers: { 'x-auth-token': token },
      });
      const { caja: cajaData, totalesPorPago: totalesData } = res.data;

      if (cajaData) {
        setCajaAbierta(cajaData);
    setResumenCaja(totalesData);
      }
    } catch (error) {
      toast.error("Error al actualizar la caja");
    }
  };

  const manejarCerrarCaja = () => {
    localStorage.removeItem('cajaAbiertaId');
    setCajaAbierta(null);
  setResumenCaja({});
  };

  return (
    <div className="container mx-auto p-6">
      {!cajaAbierta ? (
        <AperturaCaja onCajaAbierta={manejarCajaAbierta} />
      ) : (
        <>
          <RegistroMovimiento
            caja={cajaAbierta}
            resumen={resumenCaja}
            onMovimientoRegistrado={manejarMovimiento}
          />
          <CierreCaja
            caja={cajaAbierta}
            resumen={resumenCaja}
            onCerrarCaja={manejarCerrarCaja}
          />
        </>
      )}
    </div>
  );
};

export default CajaManager;
